<template>
  <detail-item
    tag="label"
    :name-spacing="nameSpacing"
  >
    <q-checkbox v-model="client.send_email">
      <q-item-label>{{ label }}</q-item-label>
      <q-item-label caption>
        By sending a {{ sublabel }}<span v-if="email && email.length > 0"> to <b>{{ email }}</b></span>, the user can log in to Client Connect and download reports or invoices that you assign to them.
      </q-item-label>
    </q-checkbox>
  </detail-item>
</template>

<script>
export default {
  props: {
    nameSpacing: {
      type: Number
    },
    email: {
      type: String,
      required: true
    },
    client: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      default: 'Send request to sign up via Client Connect'
    },
    sublabel: {
      type: String,
      default: 'signup request'
    }
  }
}
</script>
